import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Section, SectionHeading, CTAButton } from './shared';
// 14 — FEES EXPLAINED · [Trust] [Conversion]
// Plain-English fees explainer, NOT a pricing table. Every figure/term marked [VERIFY].
const feeItems = [{
  term: 'Initial discussion',
  body: 'The cost (if any) of your first confidential discussion is confirmed before you speak with us.'
}, {
  term: 'No win, no fee',
  body: 'Whether a no-win-no-fee arrangement is available, and its exact conditions, is explained in writing before you engage us.'
}, {
  term: 'Disbursements',
  body: 'Out-of-pocket costs such as medical reports and searches, and how they are handled, are explained up front.'
}, {
  term: 'Uplift fees',
  body: 'If any uplift fee applies, when and how it is calculated is set out clearly before engagement.'
}, {
  term: 'Adverse costs',
  body: 'The risk of being ordered to pay another party’s costs, and how that is managed, is explained honestly.'
}, {
  term: 'How costs are explained',
  body: 'You receive a clear costs explanation before engagement, with the chance to ask questions.'
}];
export function FeesExplained() {
  return <Section id="fees" className="bg-canvas" data-id="element-110">
      <SectionHeading eyebrow="Costs & fees" title="Understand the Costs Before You Decide" intro="We explain our fee model in plain English before you commit to anything. Nothing important is hidden in fine print." data-id="element-111" />

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-112">
        {feeItems.map(f => <div key={f.term} className="rounded-card border border-ink/5 bg-paper p-7 shadow-card" data-id="element-113">
            <h3 className="text-h4 font-semibold text-ink" data-id="element-114">{f.term}</h3>
            <p className="mt-2 text-body text-slate" data-id="element-115">{f.body}</p>
          </div>)}
      </div>

      <div className="mt-8 flex items-start gap-3 rounded-card border border-gold/25 bg-gold/[0.07] p-6" data-id="element-116">
        <InfoIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} data-id="element-117" />
        <p className="text-body text-ink" data-id="element-118">
          Your fee arrangement is confirmed with you in writing before you
          engage us, so you always know where you stand.
        </p>
      </div>

      <div className="mt-8" data-id="element-119">
        <CTAButton href="#quick-claim-form" variant="secondary" className="px-6" data-id="element-120">
          Ask a Question About Fees
        </CTAButton>
      </div>
    </Section>;
}